const TrackUtils = {
	attachTracks: (tracks, container) => {
		tracks.forEach(track => TrackUtils.attachTrack(track, container));
	},
	attachTrack: (track, container) => {
		if (track?.attach && container) {
			container.appendChild(track.attach());
		}
	},
	getTracks: participant => Array.from(participant.tracks.values())
		.filter(publication => publication.track)
		.map(publication => publication.track),
	detachTrack: track => {
		if (track.detach) {
			track.detach().forEach(element => element.remove());
		}
	},
	detachTracks: tracks => {
		tracks.forEach(track => TrackUtils.detachTrack(track));
	},
	onTrackPublished: (publication, container) => {
		if (publication.isSubscribed && publication.isTrackEnabled) {
			TrackUtils.attachTrack(publication.track, container);
		}

		publication.on('subscribed', track => {
			if (track.isEnabled) {
				TrackUtils.attachTrack(track, container);
			}
		});

		publication.on('unsubscribed', TrackUtils.detachTrack);
	}
};

export default TrackUtils;
